/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _typeof } from '../_chunks/dep-2055661d.js';
import { _ as _slicedToArray } from '../_chunks/dep-605e961c.js';
import { _ as _defineProperty } from '../_chunks/dep-8c8a3203.js';
import { _ as _objectWithoutProperties } from '../_chunks/dep-97bb7f6b.js';
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import useConfig from '../hooks/useConfig.js';
import Aside from './Aside.js';
import '../_chunks/dep-f66447d3.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-1d5f47c2.js';
import '../_chunks/dep-8670d51c.js';
import '../_chunks/dep-df9f8f04.js';
import '../_chunks/dep-9d326786.js';
import '../_chunks/dep-3542b5f1.js';
import '../_chunks/dep-79aca757.js';
import '../_chunks/dep-c7d784af.js';
import '../_chunks/dep-73c3cd54.js';
import '../_chunks/dep-ced835e2.js';
import '../_chunks/dep-1e76a561.js';
import '../_chunks/dep-6b33e1e9.js';
import '../_chunks/dep-dae4a585.js';
import '../_chunks/dep-9e05eaf2.js';
import '../_chunks/dep-0d617aaa.js';
import '../_chunks/dep-030d278c.js';
import '../_chunks/dep-868937ef.js';
import '../_chunks/dep-6f5c07a7.js';
import '../_chunks/dep-a79a1775.js';
import '../_chunks/dep-7b744c82.js';
import '../_chunks/dep-0b20126b.js';
import '../_chunks/dep-2b7035c1.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-4fce6f2f.js';
import '../_common/js/global-config/default-config.js';

var _excluded = ["className", "style", "children", "height"],
  _excluded2 = ["className", "style", "children", "height"],
  _excluded3 = ["className", "style", "children"],
  _excluded4 = ["direction", "className", "style", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Header = function Header(props) {
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var className = props.className,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    children = props.children,
    height = props.height,
    others = _objectWithoutProperties(props, _excluded);
  var renderHeight = isNaN(Number(height)) ? height : "".concat(height, "px");
  var headerClassNames = classNames("".concat(classPrefix, "-layout__header"), className);
  return /* @__PURE__ */React.createElement("header", _objectSpread({
    className: headerClassNames,
    style: _objectSpread({
      height: renderHeight
    }, style)
  }, others), children);
};
var Footer = function Footer(props) {
  var _useConfig2 = useConfig(),
    classPrefix = _useConfig2.classPrefix;
  var className = props.className,
    _props$style2 = props.style,
    style = _props$style2 === void 0 ? {} : _props$style2,
    children = props.children,
    height = props.height,
    others = _objectWithoutProperties(props, _excluded2);
  var renderHeight = isNaN(Number(height)) ? height : "".concat(height, "px");
  var footerClassNames = classNames("".concat(classPrefix, "-layout__footer"), className);
  return /* @__PURE__ */React.createElement("footer", _objectSpread({
    className: footerClassNames,
    style: _objectSpread({
      height: renderHeight
    }, style)
  }, others), children);
};
var Content = function Content(props) {
  var _useConfig3 = useConfig(),
    classPrefix = _useConfig3.classPrefix;
  var className = props.className,
    style = props.style,
    children = props.children,
    others = _objectWithoutProperties(props, _excluded3);
  var contentClassNames = classNames("".concat(classPrefix, "-layout__content"), className);
  return /* @__PURE__ */React.createElement("main", _objectSpread({
    className: contentClassNames,
    style: style
  }, others), children);
};
var Layout = function Layout(props) {
  var _classNames;
  var direction = props.direction,
    className = props.className,
    style = props.style,
    children = props.children,
    otherLayoutProps = _objectWithoutProperties(props, _excluded4);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    asides = _useState2[0],
    setAsides = _useState2[1];
  useEffect(function () {
    React.Children.forEach(children, function (child) {
      if (!child || _typeof(child) !== "object") return;
      if (child.type === Aside) setAsides([child]);
    });
  }, [children]);
  var _useConfig4 = useConfig(),
    classPrefix = _useConfig4.classPrefix;
  var layoutClassNames = classNames("".concat(classPrefix, "-layout"), (_classNames = {}, _defineProperty(_classNames, "".concat(classPrefix, "-layout--with-sider"), !!asides.length), _defineProperty(_classNames, "".concat(classPrefix, "-layout__direction-").concat(direction), direction), _classNames), className);
  return /* @__PURE__ */React.createElement("div", _objectSpread({
    className: layoutClassNames,
    style: style
  }, otherLayoutProps), children);
};
Layout.Header = Header;
Layout.Content = Content;
Layout.Footer = Footer;
Layout.Aside = Aside;
Header.displayName = "Header";
Content.displayName = "Content";
Footer.displayName = "Footer";
Layout.displayName = "Layout";

export { Layout as default };
//# sourceMappingURL=Layout.js.map
